import { SwalMessage, ToastMessage } from './Tools'


var FavoritesAndTrackingList = function () {


    // Takip Listesi
    var ProductTracking = function (form) {

        $(form).on('click', '[data-product-tracking]', function (event) {
            event.preventDefault();

            let thisButton = this;

            let productId = thisButton.getAttribute('data-id');
            let userId = thisButton.getAttribute('data-user-id');

            if (!userId) {
                ToastMessage('1', translate.product_tracking, translate.product_tracking_login)

                let button = document.querySelector('.auth-buttons');
                if (!button.querySelector('.dropdown-menu').classList.contains('show')) {
                    button.querySelector('.btn-auth').click()
                }

                return;
            }

            let data = {
                user_id: userId,
                product_id: productId,
            }

            $.ajax({
                url: apiUrl + '/UserProductTracking',
                type: "POST",
                dataType: "json",
                data: data,
                error: function error(xhr) {
                    //console.log(xhr);
                    ToastMessage('1', translate.product_tracking, xhr.responseJSON.text ?? xhr.responseJSON.message)
                },
                success: function success(xhr) {

                    if (xhr.row) {

                        thisButton.querySelector('svg').remove();
                        thisButton.insertAdjacentHTML('afterbegin', '<i class="fa-solid fa-bookmark text-main-color"></i>')

                        thisButton.querySelector('span').innerText = translate.product_tracking_remove;
                    } else {
                        thisButton.querySelector('svg').remove();
                        thisButton.insertAdjacentHTML('afterbegin', '<i class="fa-regular fa-bookmark"></i>')

                        thisButton.querySelector('span').innerText = translate.product_tracking_add;
                    }
                    ToastMessage('0', translate.product_tracking, xhr.text ?? xhr.message)
                }
            });

        })

    }

    // Beğeni Listesi
    var ProductLike = function (form) {

        $(form).on('click', '[data-product-like]', function (event) {
            event.preventDefault();

            let thisButton = this;

            let dataId = thisButton.getAttribute('data-id');
            let userId = thisButton.getAttribute('data-user-id');

            if (!userId) {
                ToastMessage('1', translate.product_like, translate.product_like_login)

                let button = document.querySelector('[data-bs-target="#login"]');
                button.click()

                return;
            }

            let data = {
                user_id: userId,
                hotel_id: dataId,
            }

            $.ajax({
                url: apiUrl + '/UserHotelLike',
                type: "POST",
                dataType: "json",
                data: data,
                error: function error(xhr) {
                    ToastMessage('1', translate.product_like, xhr.responseJSON.text ?? xhr.responseJSON.message)
                },
                success: function success(xhr) {
                    ToastMessage('1', translate.product_like, xhr.text ?? xhr.message)
                    if (xhr.row) {
                        thisButton.querySelector('svg').remove();
                        thisButton.insertAdjacentHTML('afterbegin', '<i class="fa-solid fa-heart"></i>')

                        // thisButton.querySelector('span').innerText = translate.product_like_remove;
                    } else {
                        thisButton.querySelector('svg').remove();
                        thisButton.insertAdjacentHTML('afterbegin', '<i class="fa-regular fa-heart"></i>')
                        
                        // thisButton.querySelector('span').innerText = translate.product_like_add;
                    }
                }
            });

        })

    }

    return {
        init: function () {

            const hotels = document.querySelectorAll('[data-hotel]');

            if(hotels){
                hotels.forEach(function(element){
                    ProductLike(element);
                })
            }

        },
    };

}();




$(function () {
    FavoritesAndTrackingList.init();
});